import React, { useContext, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { default as AddCircleIcon } from '@wix/da-ds/pkg/Icons/AddCircle';
import IconButton from '../../../Button/IconButton';
import { useThrottle } from '../../../utils/hooks/useThrottle';
import { useResizeObserver } from '../../../utils/hooks/useResizeObserver';
import { CommentEditorSource } from '../../../CommentEditor/redux/types';
import { CommentEditorContext, EditorContext, } from '../../../CommentEditor/context';
import { useCommentPostAction } from '../../../CommentEditor/hooks/useCommentPostAction';
import { useCommentCancelAction } from '../../../CommentEditor/hooks/useCommentCancelAction';
import s from './CommentBoxFooter.scss';
var RESIZE_THROTTLE_DELAY = 300;
var RESIZE_THROTTLE_OPTIONS = { trailing: true };
var COLLAPSE_BREAKPOINT_WIDTH = 410;
/**
 * The footer for our CommentBox editor.
 *
 * TODO: Refactor this more. There is room for this to be modularized.
 */
var CommentBoxFooter = function (_a) {
    var onCancel = _a.onCancel, className = _a.className;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _b = useContext(CommentEditorContext), isBusy = _b.isBusy, isEditorExpanded = _b.isExpanded, shouldUseFallback = _b.shouldUseFallback, editorSource = _b.editorSource;
    var _c = useContext(EditorContext), state = _c.state, toolbars = _c.toolbars;
    var Toolbar = toolbars === null || toolbars === void 0 ? void 0 : toolbars.INSERT_PLUGIN;
    var isEdit = editorSource === CommentEditorSource.Edit;
    var _d = useState(!!isMobile), isToolbarCollapsable = _d[0], setIsToolbarCollapsable = _d[1];
    var _e = useState(false), isToolbarExpanded = _e[0], setIsToolbarExpanded = _e[1];
    var rootRef = useRef(null);
    var _f = useState(0), rootWidth = _f[0], setRootWidth = _f[1];
    var handleResize = useThrottle(function () {
        if (isMobile) {
            return;
        }
        var newWidth = rootRef.current.clientWidth;
        if (newWidth !== rootWidth) {
            setRootWidth(newWidth);
            setIsToolbarCollapsable(newWidth < COLLAPSE_BREAKPOINT_WIDTH);
        }
    }, [rootWidth, isMobile], RESIZE_THROTTLE_DELAY, RESIZE_THROTTLE_OPTIONS);
    useResizeObserver(rootRef, handleResize);
    var postComment = useCommentPostAction();
    var cancelComment = useCommentCancelAction({ onCancel: onCancel });
    var handleToolbarClick = function (ev) {
        setIsToolbarExpanded(false);
    };
    return (React.createElement("footer", { className: classnames(s['root'], isEditorExpanded && s['editor-expanded'], isToolbarCollapsable && s['collapsable-toolbar'], isToolbarExpanded && s['expanded-toolbar'], className), ref: rootRef },
        !shouldUseFallback && Toolbar && (React.createElement("div", { className: s['toolbar-wrapper'] },
            React.createElement(IconButton, { className: s['toolbar-toggle'], onClick: function () { return setIsToolbarExpanded(!isToolbarExpanded); }, "aria-label": t('commentbox.a11y.button.expandToolbar') },
                React.createElement(AddCircleIcon, { size: IconSize.MEDIUM })),
            React.createElement("div", { className: s['toolbar'], onClick: handleToolbarClick },
                React.createElement(Toolbar, { className: s['editor-toolbar'] })))),
        React.createElement(PlainButtonOrLink, { disabled: isBusy, className: classnames(s['cancel-button'], s['button-activated']), onClick: cancelComment, biData: {
                evid: BiEventType.COMMENT_CANCEL_CLICK,
            } }, t('commentbox.button.cancel')),
        React.createElement(PlainButtonOrLink, { disabled: (state === null || state === void 0 ? void 0 : state.isEmpty) || isBusy, className: classnames(s['comment-button'], (state === null || state === void 0 ? void 0 : state.isEmpty) && s['button-disabled']), onClick: postComment }, isEdit
            ? t('commentbox.button.update')
            : t('commentbox.button.comment'))));
};
export default CommentBoxFooter;
//# sourceMappingURL=CommentBoxFooter.js.map